import { Button } from '@/components/button-new'

interface Props {
  id: string
  href: string
  icon: any
  title: string
  target?: string
}

const SocialShareButton: React.FC<Props> = ({
  id,
  href,
  icon,
  title,
  target
}) => (
  <Button
    as="a"
    target={target}
    href={href}
    id={id}
    theme="secondary"
    width="100%"
    size="unset"
  >
    {icon}
    {title}
  </Button>
)

export default SocialShareButton
